/* eslint-disable jsx-a11y/label-has-for */
import _ from 'underscore';
import PropTypes from 'prop-types';
import React from 'react';
import { HelpPopup } from '@bingads-webui-react/help-popup';
import { AdStrengthScore } from './ad-strength-score';
import { AdStrengthRepository } from './ad-strength-repository';
import { generateSuggestion, sortSuggestions } from './ad-strength-helper';
import { updateAdStrengthSuggestion, renewAdStrengthSuggestion } from './rsa-ad-strength-suggestion-helper';

export class AdStrengthView extends React.Component {
  static propTypes = {
    className: PropTypes.string,
    adId: PropTypes.number.isRequired,
    edm: PropTypes.objectOf(PropTypes.any).isRequired,
    i18n: PropTypes.shape({
      getString: PropTypes.func.isRequired,
    }).isRequired,
    jsdata: PropTypes.objectOf(PropTypes.any).isRequired,
    viewModel: PropTypes.objectOf(PropTypes.any).isRequired,
    isForVNext: PropTypes.bool,
    inlineSuggestionsEnabled: PropTypes.bool,
  };

  static defaultProps = {
    className: 'responsive-search-ad-strength-view',
    isForVNext: false,
    inlineSuggestionsEnabled: false,
  };

  constructor(props) {
    super(props);
    this.state = {};
    this.subscriptions = {};
    this.repository = new AdStrengthRepository({
      adId: props.adId,
      edm: props.edm,
      jsdata: props.jsdata,
    });
  }

  componentDidMount() {
    this.fetchData();

    const lazyFetchData = _.debounce(() => this.fetchData(), 1000);

    _.each(_.range(15), (i) => {
      this.subscriptions[`Headline${i}`] = this.props.viewModel[`Headline${i}`].subscribe(() => {
        lazyFetchData();
      });
      this.subscriptions[`Headline${i}Position`] = this.props.viewModel[`Headline${i}Position`].subscribe(() => {
        lazyFetchData();
      });
    });
    _.each(_.range(4), (i) => {
      this.subscriptions[`Description${i}`] = this.props.viewModel[`Description${i}`].subscribe(() => {
        lazyFetchData();
      });
      this.subscriptions[`Description${i}Position`] = this.props.viewModel[`Description${i}Position`].subscribe(() => {
        lazyFetchData();
      });
    });
    if (this.props.inlineSuggestionsEnabled) {
      this.props.viewModel.FinalUrls.extend({
        rateLimit: 1000,
      });
      this.subscriptions.FinalUrls = this.props.viewModel.FinalUrls.subscribe(() => {
        renewAdStrengthSuggestion(_.pick(this.props, 'i18n', 'viewModel', 'appState', 'token', 'odataPath', 'isForVNext'));
      });
    }
  }

  componentWillUnmount() {
    _.each(this.subscriptions, subscription => subscription.dispose());
    this.subscriptions = {};
  }

  fetchData() {
    if (!_.isNull(this.props.edm.currentAccount) || !_.isNull(this.props.viewModel.accountId)) {
      this.repository.fetchAdStrength(this.props.viewModel)
        .then((response) => {
          this.parseAdStrengthActionItems(response);
        });
    }
  }

  parseAdStrengthActionItems(response) {
    const {
      i18n,
      viewModel,
    } = this.props;
    const {
      Strength,
      ActionItems,
    } = response;

    const assets = {
      headlines: _.filter(_.map(_.range(15), i => _.result(viewModel, `Headline${i}`)), i => _.size(i) > 0),
      descriptions: _.filter(_.map(_.range(4), i => _.result(viewModel, `Description${i}`)), i => _.size(i) > 0),
      headlinePins: _.filter(_.range(15), i => _.result(viewModel, `Headline${i}Position`) !== 'None'),
      descriptionPins: _.filter(_.range(4), i => _.result(viewModel, `Description${i}Position`) !== 'None'),
    };
    const suggestions = _.map(ActionItems, item => generateSuggestion({
      i18n,
      assets,
      actionItem: item,
      strength: Strength,
    }));
    const sortedSuggestions = sortSuggestions(suggestions);

    this.setState({
      label: i18n.getString(`Ad_Strength_Score_${Strength}`),
      strength: Strength,
      suggestions: sortedSuggestions.slice(0, 4),
    });

    if (this.props.inlineSuggestionsEnabled) {
      // Update the corresponding suggestions when all ad strengthes are updated
      updateAdStrengthSuggestion(i18n, viewModel);
    }
  }

  render() {
    return (
      <div className={this.props.className}>
        <div>
          <label>
            {this.props.i18n.getString('Ad_Strength_Title')}
            <HelpPopup
              aria-label={this.props.i18n.getString('Click to learn more about {{item}}', {
                item: this.props.i18n.getString('Ad_Strength_Title'),
              })}
              topic="pop_BA_RSA_AdStrength"
            />
          </label>
        </div>
        <div className="ad-strength-content">
          <AdStrengthScore
            isForVNext={this.props.isForVNext}
            label={this.state.label}
            strength={this.state.strength}
          />
          <div className="ad-strength-suggestions">
            <ul className="ad-strength-actions">
              {_.map(this.state.suggestions, suggestion => (
                <li>
                  <span className={`ad-strength-action-${suggestion.state}`} />
                  {suggestion.suggestion}
                </li>
              ))}
            </ul>
          </div>
        </div>
        <div className="ad-strength-suggestions-detail" />
      </div>
    );
  }
}
